import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import UserBadges from "@/components/nav/UserBadges";
import Wordmark from "@/components/brand/Wordmark";

export default function Nav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [activeTeam, setActiveTeam] = useState(null);

  // Fetch the user's active team for the Nav badge.
  useEffect(() => {
    const activeId = user?.active_team_id;
    if (!activeId) return undefined;
    let cancelled = false;
    api
      .get("/teams/mine")
      .then(({ data }) => {
        if (cancelled) return;
        const t = (data.teams || []).find((x) => x.team_id === data.active_team_id);
        setActiveTeam(t || null);
      })
      .catch(() => {
        if (!cancelled) setActiveTeam(null);
      });
    return () => {
      cancelled = true;
    };
  }, [user?.active_team_id]);

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.assign(`https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`);
  };

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header
      data-testid="top-nav"
      className="sticky top-0 z-40 backdrop-blur-xl bg-[#050505]/80 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-10 h-auto md:h-16 py-3 md:py-0 flex flex-wrap items-center justify-between gap-3">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 text-white min-h-[44px] py-2 -my-2" aria-label="PivotProof home">
          <Wordmark height={22} />
        </Link>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <UserBadges user={user} activeTeam={activeTeam} />
              <button
                data-testid="logout-btn"
                onClick={handleLogout}
                className="text-xs uppercase tracking-[0.18em] text-white/60 hover:text-white"
              >
                Logout
              </button>
            </>
          ) : (
            <button
              data-testid="login-btn"
              onClick={handleLogin}
              className="border border-white/25 hover:border-white bg-black text-white px-5 py-2.5 min-h-[44px] font-mono text-xs uppercase tracking-[0.2em] transition-colors inline-flex items-center gap-2"
            >
              Sign in →
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
